import { Box, Button, Typography } from "@material-ui/core";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import { useState } from "react";
import {
  EPOCUS_PRIMARY,
  EPOCUS_SELECTED_BG,
  EPOCUS_TEXT_PRIMARY,
  EPOCUS_WHITE,
  rem,
} from "../epocus-palette";
import { PatientSearchDialog } from "./patient-search-dialog";
import type { PatientSearchResult } from "./use-patient-search";

type Props = {
  selectedPatient: PatientSearchResult | null;
  onSelect: (patient: PatientSearchResult | null) => void;
  disabled?: boolean;
};

export const PatientSearchField: FC<Props> = ({
  selectedPatient,
  onSelect,
  disabled = false,
}) => {
  const [dialogOpen, setDialogOpen] = useState(false);

  const handleClear = () => {
    onSelect(null);
  };

  // Once a patient is picked, lock the field. The chip is the only way to
  // change selection — reopening search can't silently drop it.
  if (selectedPatient) {
    return (
      <Box
        display="flex"
        alignItems="center"
        style={{
          gap: 8,
          padding: "8px 12px",
          border: `2px solid ${EPOCUS_PRIMARY}`,
          backgroundColor: EPOCUS_SELECTED_BG,
          borderRadius: 8,
        }}
        aria-label="Selected patient"
      >
        <Typography
          style={{
            fontSize: rem(14),
            fontWeight: 600,
            color: EPOCUS_TEXT_PRIMARY,
            flex: 1,
          }}
        >
          ✓ {selectedPatient.displayName}
        </Typography>
        <Button
          size="small"
          onClick={handleClear}
          disabled={disabled}
          aria-label="Change selected patient"
          style={{
            minWidth: 0,
            padding: "2px 8px",
            color: EPOCUS_PRIMARY,
            fontSize: rem(13),
            fontWeight: 600,
            textTransform: "none",
          }}
        >
          Change
        </Button>
      </Box>
    );
  }

  return (
    <>
      <Button
        fullWidth
        variant="outlined"
        startIcon={<PersonAddIcon />}
        onClick={() => setDialogOpen(true)}
        disabled={disabled}
        aria-label="Search for a patient"
        style={{
          justifyContent: "flex-start",
          padding: "10px 14px",
          border: `1.5px solid ${EPOCUS_PRIMARY}`,
          backgroundColor: EPOCUS_WHITE,
          color: EPOCUS_PRIMARY,
          textTransform: "none",
          fontWeight: 600,
          fontSize: rem(14),
        }}
      >
        Search for a patient
      </Button>
      <PatientSearchDialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        onSelect={onSelect}
      />
    </>
  );
};
